import React from "react";
import TickIcon from "../../assets/images/TickIcon.png";
import LandPrepIcon from "../../assets/svg/LandPrep.svg";
import SeedTreatmentIcon from "../../assets/svg/SeedTreatment.svg";
import SeedCuttingIcon from "../../assets/svg/SeedCutting.svg";
import BasalDoseIcon from "../../assets/svg/BasalDose.svg";
import PlantingFormIcon from "../../assets/svg/PlantingForm.svg";
import WeedicideApplicationIcon from "../../assets/svg/WeedicideDayWise.svg";
import FertilizerIcon from "../../assets/svg/FertilizerDayWise.svg";
import IrrigationIcon from "../../assets/svg/IrrigationDaywise.svg";
import CropPortectionIcon from "../../assets/svg/CropProtectionDayWise.svg";
import LenoBagsIcon from "../../assets/svg/LenoBagsDayWise.svg";
import CropHealthIcon from "../../assets/svg/CropHealthDayWise.svg";
import HarvestingFormIcon from "../../assets/svg/HarvestingForm.svg";

const PreparationIconWithTick = ({ status, activityType }) => {
	const getActivityIcon = () => {
		const activityIcons = {
			land_preparation: {
				icon: LandPrepIcon,
				alt: "Land Preparation",
			},
			seed_treatment: {
				icon: SeedTreatmentIcon,
				alt: "Seed Treatment",
			},
			seed_cutting: {
				icon: SeedCuttingIcon,
				alt: "Seed Cutting",
			},
			basal_dose: {
				icon: BasalDoseIcon,
				alt: "Basal Dose",
			},
			planting: {
				icon: PlantingFormIcon,
				alt: "Planting",
			},
			weedicide: {
				icon: WeedicideApplicationIcon,
				alt: "Weedicide application",
			},
			fertilizer: {
				icon: FertilizerIcon,
				alt: "Fertilizer",
			},
			irrigation_schedule: {
				icon: IrrigationIcon,
				alt: "Irrigation Schedule",
			},
			crop_protection: {
				icon: CropPortectionIcon,
				alt: "CropProtection",
			},
			leno_bags: {
				icon: LenoBagsIcon,
				alt: "Leno Bags",
			},
			book_to_check_crop_health: {
				icon: CropHealthIcon,
				alt: "Book here to check crop health",
			},
			harvesting: {
				icon: HarvestingFormIcon,
				alt: "Harvesting",
			},
		};

		const { icon: IconComponent, alt } = activityIcons[activityType] || {};

		return (
			<>
				<img src={IconComponent} alt={alt} />
				{status && (
					<img
						src={TickIcon}
						alt='Tick'
						style={{
							position: "absolute",
							top: 15,
							right: 15,
							transform: "translate(22%, -28%)",
							zIndex: 1,
							fontSize: "10px",
						}}
					/>
				)}
			</>
		);
	};

	return <>{getActivityIcon()}</>;
};

export default PreparationIconWithTick;
